import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'LEN',
  category: FunctionCategory.TEXT,
  description: 'Returns the length of each string in a column or a single string.',
  shortDescription: 'Length of a string',
  params: [
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string.',
    },
  ],
} satisfies AnalysisFunction;
